import { Component, OnInit } from '@angular/core';
import { AppBreadcrumbService } from '../app.breadcrumb.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { utility } from '../common/utility';
import { catchError } from 'rxjs/internal/operators/catchError';
import * as moment from 'moment';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
    events: any[] = [];
    calendarwizURL: string = "http://www.calendarwiz.com/calendars/calendar.php?crd=naiglobal&";
    displayEventDetail: boolean = false;
    selectedEvent: any;

    constructor(private breadcrumbService: AppBreadcrumbService,
                private http: HttpClient) { }

    ngOnInit(): void {
        this.breadcrumbService.setItems([this.breadcrumbService.calendar]);
        this.getCalendarEvents();
    }

    getCalendarEvents() {
        var calendarIdentifier = 'naiglobal';
        var today = new Date(); // today's date
        var df = 365; // # days into future to pull events

        var bm = today.getMonth() + 1;
        var bd = today.getDate();
        var by = today.getFullYear();

        var end = new Date(today.getTime() + (60 * 60 * 24 * df * 1000));

        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        var em = end.getMonth() + 1;
        var ed = end.getDate();
        var ey = end.getFullYear();

        var url = 'https://www.calendarwiz.com/cwapi.php?bm=' + bm + '&bd=' + bd + '&by=' + by + '&em=' + em + '&ed=' + ed + '&ey=' + ey + '&fmt=json&view=d&crd=' + calendarIdentifier + '&callback=?';
        this.getCalendarEventsService(url).subscribe(data => {
            if (data != undefined && data.eventdetails != undefined) {
                var calendarEvents = [];
                for (var item of data.eventdetails) {
                    var x = new Date(item.event_year, item.event_month - 1, item.event_day, item.starthour, item.startminute, 0);
                    item.dayOfWeek = days[x.getDay()];
                    item.eventmonth = month[x.getMonth()];
                    calendarEvents.push(item);
                }
                this.events = [...calendarEvents];
            }          
        });
    }  

    getCalendarEventsService(url): Observable<any> {     
        return this.http.jsonp(url, 'callback');
    }

    removeHTML(str) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || "";
    }

    addStyle(str) {
        return str.replace("<a", "<a class=\"hyperLink\"");
    }

    navMailto() {
        var EmailTo = "help@naiglobal.com";
        var Subject = "NAI Event Submission";
        window.location.href = "mailto:" + EmailTo + "?subject=" + Subject;
    }

    navUrl() {      
        window.open(this.calendarwizURL, "_system", "location=yes");
    }

    showViewEventDetailDialog(event) {
        this.displayEventDetail = true;
        this.selectedEvent = event;
    }

    closeViewEventDetailDialog() {
        this.displayEventDetail = false;
    }

    addToCalendar() {
        var event = this.selectedEvent;       
        var sTime = this.eventDateToICSString(event.event_year, event.event_month, event.event_day, event.starthour, event.startminute, event.startampm);
        var eTime = this.eventDateToICSString(event.end_event_year, event.end_event_month, event.end_event_day, event.endhour, event.endminute, event.endampm);
        //var email = (event.email) ? event.email : $scope.email;
        var email = event.email

        var icsMSG = "BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//" + event.title + "//NONSGML v1.0//EN\nBEGIN:VEVENT\nUID:" + email +
            "\nDTSTAMP:" + moment.unix(event.start_timestamp_gmt).utc().format("YYYYMMDDTHHmmss") + 'Z' +
            "\nATTENDEE;CN=" + event.contact + ";RSVP=TRUE:MAILTO:" + email +
            "\nORGANIZER;CN=Me:MAILTO::" + email +
            "\nDTSTART:" + sTime +
            "\nDTEND:" + eTime +
            "\nLOCATION:" + event.location_name +
            "\nSUMMARY:" + event.title +
            "\nDESCRIPTION:" + this.removeHTML(event.description) +
            "\nEND:VEVENT\nEND:VCALENDAR";

        var url = "data:text/calendar;charset=utf8," + escape(icsMSG);

        var blob = new Blob([icsMSG], { type: 'text/calendar' });
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, 'download.ics');
        }
        else {

            window.location.href = url;
        }
    }

    roundTwo(val) {
        return val.length == 1 ? "0" + val : val;
    }

    eventDateToICSString(year, month, day, hour, minute, ampm) {
        var d = moment(year + "-" + month + "-" + day + " " + this.roundTwo(hour) + ":" + this.roundTwo(minute) + " " + ampm, "YYYY-M-D hh:mm a");
        return moment(d).format("YYYYMMDDTHHmmss");
    }
}
